import { Injectable } from '@angular/core';

import { SidenavItem } from './sidenav-item/sidenav-item.interface';
import { RunTimeDataService } from '@leandredev/common-ng16/infraService';
import { EntityReference } from '@leandredev/adaptivai-common-lib';

/**
 * Menu pour un scoped admin.
 */
const scopedAdminMenu: SidenavItem[] = [
  { name: 'Utilisateurs', type: 'subheading' },
  { routeOrFunction: '/data/UserClient/list', name: 'Clients app', icon: 'person', pathMatchExact: true },
  { routeOrFunction: '/data/UserClientGroup/list', name: 'Groupes d’utilisateurs', icon: 'group_work', pathMatchExact: true },
  { name: 'Documents Admin', type: 'subheading' },
  { routeOrFunction: '/data/Tag/list', name: 'Tags de documents', icon: 'label', pathMatchExact: true }
];

/**
 * Menu pour un admin.
 */
const normalAdminMenu: SidenavItem[] = [
  { name: 'Application Admin', type: 'subheading', customClass: 'first-subheading' },
  { routeOrFunction: '/data/ServiceDeployed/list/', name: 'Service Deployed', icon: 'dns', pathMatchExact: true },
  { routeOrFunction: '/stats/', name: 'Platform usage', icon: 'bar_chart', pathMatchExact: true },
  { routeOrFunction: '/data/CopywriterStyleRecord/list/', name: 'Copywriter Styles', icon: 'history_edu', pathMatchExact: true },
  { routeOrFunction: '/apiError/', name: 'Api Errors', icon: 'error', pathMatchExact: true },

  { name: 'Documents Admin', type: 'subheading' },
  { routeOrFunction: '/data/Tag/list', name: 'Tags de documents', icon: 'label', pathMatchExact: true },
  { routeOrFunction: '/data/TagType/list', name: 'Type des Tags', icon: 'category', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagTypeMapper/list/', name: 'ExternalTagTypeMapper', icon: 'merge_type', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagMapper/list/', name: 'ExternalTagMapper', icon: 'swap_horiz', pathMatchExact: true },

  { name: 'Utilisateurs', type: 'subheading' },
  { routeOrFunction: '/data/UserClient/list', name: 'Clients app', icon: 'person', pathMatchExact: true },
  { routeOrFunction: '/data/UserClientGroup/list', name: 'Groupes d’utilisateurs', icon: 'group_work', pathMatchExact: true },
  { routeOrFunction: '/data/EntityReference/list', name: 'Entities', icon: 'device_hub', pathMatchExact: true },
  { name: 'Disclaimer', type: 'subheading' },
  { routeOrFunction: '/data/Disclaimer/list', name: 'Disclaimer', icon: 'visibility', pathMatchExact: true }
];

/**
 * Menu pour un super administrateur.
 */

const superAdminMenu: SidenavItem[] = [
  { name: 'Application Admin', type: 'subheading', customClass: 'first-subheading' },
  { routeOrFunction: '/data/ServiceDeployed/list/', name: 'Service Deployed', icon: 'dns', pathMatchExact: true },
  { routeOrFunction: '/stats/', name: 'Platform usage', icon: 'bar_chart', pathMatchExact: true },
  { routeOrFunction: '/apiError/', name: 'Api Errors', icon: 'error', pathMatchExact: true },
  { routeOrFunction: '/data-privacy/', name: 'Data Privacy', icon: 'lock', pathMatchExact: true },
  { routeOrFunction: '/data/UserRole/list/', name: 'Roles', icon: 'security', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalRoleMapper/list/', name: 'Roles Mapper', icon: 'compare_arrows', pathMatchExact: true },
  { routeOrFunction: '/data/Assistant/list/', name: 'Assistants', icon: 'android', pathMatchExact: true },
  { routeOrFunction: '/data/AvailableAiModels/list/', name: 'Models', icon: 'psychology', pathMatchExact: true },
  { routeOrFunction: '/data/CopywriterStyleRecord/list/', name: 'Copywriter Styles', icon: 'history_edu', pathMatchExact: true },
  { routeOrFunction: '/data/TranslatorStyle/list/', name: 'Translator Styles', icon: 'translate', pathMatchExact: true },
  { routeOrFunction: '/data/AdaptivIcon/list', name: 'Icones ', icon: 'insert_emoticon', pathMatchExact: true },
  { routeOrFunction: '/data/Template/list', name: 'Template', icon: 'view_quilt', pathMatchExact: true },

  { name: 'Documents Admin', type: 'subheading' },
  { routeOrFunction: '/data/Tag/list', name: 'Tags de documents', icon: 'label', pathMatchExact: true },
  { routeOrFunction: '/data/TagType/list', name: 'Type des Tags', icon: 'category', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagTypeMapper/list/', name: 'ExternalTagTypeMapper', icon: 'merge_type', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagMapper/list/', name: 'ExternalTagMapper', icon: 'swap_horiz', pathMatchExact: true },
  { name: 'Disclaimer', type: 'subheading' },
  { routeOrFunction: '/data/Disclaimer/list', name: 'Disclaimer', icon: 'visibility', pathMatchExact: true },
  { name: 'AGENT X Admin', type: 'subheading' },
  { routeOrFunction: '/data/AGXToolBox/list', name: 'ToolBox', icon: 'build', pathMatchExact: true },
  { routeOrFunction: '/data/AGXCo2Emission/list', name: 'CO2 emissions', icon: 'spa', pathMatchExact: true },
  { routeOrFunction: '/data/agentXLog/list', name: 'Logs', icon: 'receipt', pathMatchExact: true },
  { routeOrFunction: '/data/Artifact/list', name: 'Artifacts', icon: 'folder_special', pathMatchExact: true },

  { name: 'Shared Library', type: 'subheading' },
  { routeOrFunction: '/sharedLibraryCatalog', name: 'Catalog', icon: 'store', pathMatchExact: true },
  { routeOrFunction: '/data/SharedLibrarySubscription/list/', name: 'Subscription', icon: 'subscriptions', pathMatchExact: true },
  { routeOrFunction: '/data/SharedLibraryApiKey/list/', name: 'API keys', icon: 'vpn_key', pathMatchExact: true },

  { name: 'Utilisateurs', type: 'subheading' },
  { routeOrFunction: '/data/UserAdmin/list', name: 'Utilisateurs Admin', icon: 'people', pathMatchExact: true },
  { routeOrFunction: '/data/UserClient/list', name: 'Clients app', icon: 'person', pathMatchExact: true },
  { routeOrFunction: '/data/UserMcp/list', name: 'Clients MCP', icon: 'settings_input_antenna', pathMatchExact: true },
  { routeOrFunction: '/data/UserClientGroup/list', name: 'Groupes d’utilisateurs', icon: 'group_work', pathMatchExact: true },
  { routeOrFunction: '/data/EntityReference/list', name: 'Entities', icon: 'device_hub', pathMatchExact: true },

  { name: 'Super Admin Debug', type: 'subheading' },
  { routeOrFunction: '/data/ImportingFile/list/', name: 'Import de documents', icon: 'cloud_upload', pathMatchExact: true },
  { routeOrFunction: '/data/ConvertingFile/list/', name: 'Conversion de documents', icon: 'transform', pathMatchExact: true },
  { routeOrFunction: '/llm-actions-list', name: 'LLM Messages', icon: 'all_inbox', pathMatchExact: true },
  { routeOrFunction: '/data/adaptivLog/list', name: 'Adaptiv AI Logs', icon: 'bug_report', pathMatchExact: true },

  { name: '-----', type: 'subheading' }
];

const sectionIcons: Record<string, string> = {
  'Application Admin': 'settings',
  'Documents Admin': 'folder',
  Disclaimer: 'policy',
  'AGENT X Admin': 'memory',
  'Shared Library': 'library_books',
  Utilisateurs: 'people',
  'Super Admin Debug': 'bug_report'
};

function groupMenuSections(items: SidenavItem[]): SidenavItem[] {
  const groupedItems: SidenavItem[] = [];
  let currentSection: SidenavItem | undefined;

  items.forEach((item) => {
    if (item.type === 'subheading') {
      currentSection = sectionIcons[item.name]
        ? { name: item.name, icon: sectionIcons[item.name], subItems: [] }
        : undefined;

      if (currentSection) {
        groupedItems.push(currentSection);
      }
    } else if (currentSection?.subItems) {
      currentSection.subItems.push(item);
    } else {
      groupedItems.push(item);
    }
  });

  return groupedItems;
}

@Injectable()
export class SidenavNavigationData {
  public navigationAppItems: SidenavItem[] = [];

  constructor(protected runtimeDataProvider: RunTimeDataService) {
    this.runtimeDataProvider.getObservableStore('ConfService').subscribe((data: { superAdmin: boolean; entities: EntityReference[] }) => {
      if (data && data.superAdmin) {
        this.navigationAppItems = groupMenuSections(superAdminMenu);
      } else if (data && !data.superAdmin && data.entities && data.entities.length > 0) {
        this.navigationAppItems = groupMenuSections(scopedAdminMenu);
      } else {
        this.navigationAppItems = groupMenuSections(normalAdminMenu);
      }
    });
  }

  openQuickPanel(): void {
    return;
  }
}
